module.exports = __webpack_public_path__ + "static/assets/451f97f901d2159e62f3ee0a0f25bf34.svg";